import * as React from 'react';
import {translate} from 'react-i18next';

import {connect, Dispatch} from "react-redux";

import {Redirect} from "react-router-dom";
import {Location} from "history";

import {WebAPI} from "../services/WebAPI";

import {MenuDto, InitDto, MaintenanceDto, MaintenanceListDto} from "../services/Client";

import '../App.css';
import {Grid, Container, Form, Button, Segment, Loader} from "semantic-ui-react";
import ProMTLogo from '../components/ProMTLogo';
import {LOCALTOKENKEY, POSTLOGOUTURL, PPNTOKEN, REFRESHTOKEN} from '../services/BaseClient';
import * as jwtDecode from "jwt-decode";
import {toast} from "react-toastify";
import {renderErrorToast} from "../utils/FeedbackMessageUtils";
import GeneralActions from "../redux/actions/GeneralActions";
import {compose} from 'redux';
import {selectClient, selectBaseLinks} from '../redux/selectors';
import HATEOASClient from 'src/services/HATEOASClient';
import {IError} from 'src/components/FeedbackMessage';
import {IReduxState} from '../redux/IReduxState';

// Set of possible properties for this View
interface IMapStateToProps {
    client: HATEOASClient;
    baseLinks?: MenuDto;
}

interface IMapDispatchToProps {
    LoginAction: (toke: string) => void;
    AddLoadingMessage: (loadingMsgInitData: string) => void;
    ReceiveBaseLinksAction: (baseLinks: MenuDto) => void;
    ReceiveInitDataAction: (initDto: any) => void;
    RemoveLoadingMessage: (loadingMsgInitData: string) => void;
    ReceiveMaintenanceStatus: (maintenanceStatus: MaintenanceListDto) => void;
}

interface ILoginViewParams extends IMapStateToProps, IMapDispatchToProps {
    t: reactI18Next.TranslationFunction;
    location?: Location;
    history: any;
}

// State of this view
interface ILoginViewState {
    username: string;
    password: string;
    isLoading: boolean;
    code: string;
}
// TODO refactor this component and remove async/await implementation
class LoginView extends React.Component<ILoginViewParams, ILoginViewState> {
    constructor(props: ILoginViewParams) {
        super(props);

        this.state = {
            username: "",
            password: "",
            code: "",
            isLoading: true,
        };
    }

    componentWillUnmount(): void {
        toast.dismiss();
    }
    async onPPNLogin() {
        try {
            const ppnurl = await WebAPI.getAuthUrl();
            // Find the index of the first occurrence of "/"
            const endIndex = ppnurl.indexOf("/", 8); // Start searching from index 8 to avoid including "https://"

            // Extract the substring from the beginning of the URL to the index of "/"
            const desiredSubstring = ppnurl.substring(0, endIndex);
            localStorage.setItem(POSTLOGOUTURL, desiredSubstring);
            window.location.assign(ppnurl);
        } catch (reason) {
            const builtReason = {
                response:
                {
                    data:
                    {
                        message: this.props.t("ERRORS:LOGIN_FAIL_MESSAGE"),
                        status: reason.response.status
                    },
                    status: reason.response.status
                }
            };
            const loginError: IError = {
                message: "ERRORS:LOGIN_FAILED",
                details: builtReason,
                timestamp: Date.now()
            };
            renderErrorToast(loginError);
        }
    }
    async componentDidMount() {
        // @ts-ignore
        const params = new URLSearchParams(this.props.location.search);
        const code = params.get('code');
        if (code) {
            this.setState({code});
            this.onCallback();
            console.log(code);
        } else if (!this.props.client.isAuthenticated()) {
            this.onPPNLogin();
        }
        this.setTokenRefreshInterval();
    }
    setTokensLocalStorage = (ppnToken: string, refreshToken: string) => {
        if (ppnToken) {
            sessionStorage.setItem(PPNTOKEN, ppnToken);
        }
        if (refreshToken) {
            sessionStorage.setItem(REFRESHTOKEN, refreshToken);
        }
    }

    getToken = async () => {
        const loadingMsgInitData = this.props.t("LOAD_INITIAL");
        try {
            this.setState({isLoading: true});
            // @ts-ignore
            const params = new URLSearchParams(this.props.location.search);
            const code = params.get('code');
            const {access_token, refresh_token} = await WebAPI.getPPNToken(code || '');
            const ppnToken = access_token;
            this.setTokensLocalStorage(ppnToken, refresh_token);
            this.setState({isLoading: false});
            const token = await WebAPI.getPromtToken(ppnToken);
            this.props.LoginAction(token);
            this.props.AddLoadingMessage(loadingMsgInitData);
            // login was successful; request base links
            const baseLinks: MenuDto = await this.props.client.GET_baseLinks().execute();
            // base links received; request user info for the logged-in user
            this.props.ReceiveBaseLinksAction(baseLinks);
            const isMaintainance = await this.onCheckMaintenanceStatus();
            if (isMaintainance) return;
            if (!this.props.client.GET_initdata(baseLinks).canExecute()) {
                throw new Error("Unable to fetch init data due to missing base link.");
            }
            const initDto: InitDto = await this.props.client.GET_initdata(baseLinks).execute();
            this.props.ReceiveInitDataAction(initDto);
            this.props.RemoveLoadingMessage(loadingMsgInitData);

        } catch (reason) {
            if (reason && reason.response && reason.response.status === 401) {
                const builtReason = {
                    response:
                    {
                        data:
                        {
                            message: this.props.t("ERRORS:LOGIN_FAIL_MESSAGE"),
                            status: reason.response.status
                        },
                        status: reason.response.status
                    }
                };
                const loginError: IError = {
                    message: "ERRORS:LOGIN_FAILED",
                    details: builtReason,
                    timestamp: Date.now()
                };
                this.props.history.push("/login");
                renderErrorToast(loginError);
            } else {
                let currentAttempts: number = 0;
                if (localStorage.getItem('attempts') === null) {
                    localStorage.clear();
                    sessionStorage.clear();
                    currentAttempts = parseInt('0', 10);
                    localStorage.setItem('attempts', (currentAttempts + 1).toString());
                    this.props.history.push("/login");
                    setTimeout(
                        () => {
                            window.location.reload();
                        },
                        500
                    );
                } else {
                    currentAttempts = parseInt(localStorage.getItem('attempts') as string, 10);
                    localStorage.setItem('attempts', (currentAttempts + 1).toString());
                    this.props.history.push("/login");
                    if (currentAttempts <= 2) {
                        setTimeout(
                            () => {
                                window.location.reload();
                            },
                            500
                        );
                    } else {
                        this.props.history.push("/login");
                        const loginError: IError = {
                            message: "Error in Issuing Token",
                            details: reason,
                            timestamp: Date.now()
                        };
                        renderErrorToast(loginError);
                    }
                }
            }

        }
    }
    setTokenRefreshInterval() {
        setInterval(
            async () => {
                const data = await WebAPI.slientRefreshToken(
                    sessionStorage.getItem(REFRESHTOKEN) as string,
                    sessionStorage.getItem(LOCALTOKENKEY) as string
                );
                if (data) {
                    this.setTokensLocalStorage(data.access_token, data.refresh_token);
                    const token = await WebAPI.getPromtToken(data.access_token);
                    this.props.LoginAction(token);
                }
            },
            720000,
        );
    }
    onCheckMaintenanceStatus = async () => {
        if (this.props.baseLinks) {
            const maintenanceStatus = await this.props.client.GET_maintenanceStatus(this.props.baseLinks).execute();
            if (maintenanceStatus.elements) {
                if (maintenanceStatus.elements[0].active) {
                    this.props.ReceiveMaintenanceStatus(maintenanceStatus);
                    this.props.history.push("/maintenance");
                    return true;
                }
            }
        }
        return false;
    }
    isTokenExpired = (token: string) => {
        if (!token) return true; // No token is treated as expired
        try {
            const decoded: any = jwtDecode(token);
            const currentTime = Date.now() / 1000; // Convert to seconds
            return decoded.exp < currentTime;
        } catch (error) {
            return true; // Treat invalid tokens as expired
        }
    }
    async onCallback() {
        const token = sessionStorage.getItem(LOCALTOKENKEY) as string;
        if (token && !this.isTokenExpired(token)) {
            await this.onLogin(token);
        } else {
            this.getToken();
        }
    }

    async onLogin(persistentToken?: string) {
        try {
            this.setState({isLoading: true});
            // reuse persitent token or call web api and try to login
            const token = persistentToken;
            if (!token) {
                throw new Error("JWT invalid after login.");
            }
            this.props.LoginAction(token);
        } catch (reason) {
            // forward the error to the login view state
            // TODO this needs to be refactored and the message to be sent from backend.
            // passing the reason directly, throws an error
            const builtReason = {
                response:
                {
                    data:
                    {
                        message: this.props.t("ERRORS:LOGIN_FAIL_MESSAGE"),
                        status: reason.response.status
                    },
                    status: reason.response.status
                }
            };
            const loginError: IError = {
                message: "ERRORS:LOGIN_FAILED",
                details: builtReason,
                timestamp: Date.now()
            };
            renderErrorToast(loginError);
            this.setState({
                isLoading: false
            });

            // there's nothing else to do if login failed
            return;
        }

        const loadingMsgInitData = this.props.t("LOAD_INITIAL");
        try {
            this.props.AddLoadingMessage(loadingMsgInitData);

            // login was successful; request base links
            const baseLinks: MenuDto = await this.props.client.GET_baseLinks().execute();
            // base links received; request user info for the logged-in user
            this.props.ReceiveBaseLinksAction(baseLinks);
            const isMaintainance = await this.onCheckMaintenanceStatus();
            if (isMaintainance) return;

            if (!this.props.client.GET_initdata(baseLinks).canExecute()) {
                throw new Error("Unable to fetch init data due to missing base link.");
            }
            const initDto: InitDto = await this.props.client.GET_initdata(baseLinks).execute();
            this.props.ReceiveInitDataAction(initDto);
            this.props.RemoveLoadingMessage(loadingMsgInitData);
        } catch (reason) {
            localStorage.clear();
            sessionStorage.clear();
            this.props.history.push("/login");
        }
    }

    render() {
        const {t, client, baseLinks} = this.props;
        if (client.isAuthenticated() && baseLinks) {
            // we are already authenticated; redirect to original address
            const redirect = localStorage.getItem('redirect');
            if (redirect) {
                localStorage.removeItem('redirect');
                return <Redirect to={redirect} />;
            }
            return <Redirect to="/" />;
        }
        return (
            <div className="login-view-container porsche-background" >
                {this.state.isLoading
                    &&
                    <Loader style={{"display": "block"}} content="Loading..." />
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    client: selectClient(state),
    baseLinks: selectBaseLinks(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    LoginAction: (token: string) => dispatch(GeneralActions.LoginAction(token)),
    AddLoadingMessage: (loadingMsgInitData: string) => dispatch(GeneralActions.AddLoadingMessage(loadingMsgInitData)),
    ReceiveBaseLinksAction: (baseLinks: MenuDto) => dispatch(GeneralActions.ReceiveBaseLinksAction(baseLinks)),
    ReceiveInitDataAction: (initDto: any) => dispatch(GeneralActions.ReceiveInitDataAction(initDto)),
    RemoveLoadingMessage: (loadingMsgInitData: string) => dispatch(GeneralActions.RemoveLoadingMessage(loadingMsgInitData)),
    ReceiveMaintenanceStatus: (maintenanceStatus: MaintenanceListDto) => dispatch(GeneralActions.ReceiveMaintenanceStatus(maintenanceStatus)),
});

// connect export with translate for translation and connect for state propagation
export default compose<React.ComponentType<any>>(
    translate(['LOGIN', 'ERRORS']),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(LoginView);



// WEBPACK FOOTER //
// ./src/views/LoginView.tsx